import Cookies from 'js-cookie'
import { sharedCookieDomain } from '@/platform/config/domainPolicy'

const REFERRAL_COOKIE = 'referrer_code'

function cookieOptions(): Cookies.CookieAttributes {
  return {
    path: '/',
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
    domain: sharedCookieDomain(window.location.hostname),
  }
}

export function readReferralCode(): string | null {
  return Cookies.get(REFERRAL_COOKIE)?.trim() || null
}

export function storeReferralCode(code: string): void {
  Cookies.set(REFERRAL_COOKIE, code.trim(), { ...cookieOptions(), expires: 365 })
}

export function clearReferralCode(): void {
  Cookies.remove(REFERRAL_COOKIE, cookieOptions())
  Cookies.remove(REFERRAL_COOKIE, { path: '/' })
}

export function captureReferralCode(search: string): void {
  const code = new URLSearchParams(search).get('ref')?.trim()
  if (code) storeReferralCode(code)
}
